import axiosConfig from '../axiosConfig';
import _ from 'lodash';
import CryptoJS from 'crypto-js';

export default {
	/* 
        GET     /api/v1/items
    */
	// items(selected) {
	// 	return axiosConfig.get('/items', { params: selected });
	// },

	/* 
        GET     /api/v1/dashboard/pfizer/market
        GET     /api/v1/dashboard/market
    */
	market(selected) {
		const companyID = localStorage.getItem('companyID');
		const decrypted = CryptoJS.AES.decrypt(companyID, process.env.VUE_APP_GOOGLE_SITE_KEY).toString(
			CryptoJS.enc.Utf8
		);
		
		const parsed_decrypted = JSON.parse(decrypted);

		if(!parsed_decrypted){
			localStorage.clear();
			window.location = '/';
		}
		else if (parsed_decrypted === 14) {
			return axiosConfig.get('/dashboard/pfizer/market', { params: selected });
		} else{
			return axiosConfig.get('/dashboard/market', { params: selected });
		}
	},

	/* 
        GET     /api/v1/dashboard/pfizer/products
    */
	products(selected) {
		return axiosConfig.get('/dashboard/pfizer/products', {
			params: selected,
		});
	},

	/*
    |-------------------------------------------------------------------------------
    | Dropdown
    |-------------------------------------------------------------------------------
    */

	/*
        GET 	/api/v1/dashboard/pfizer/portfolios
	*/
	portfolios(selected) {
		return axiosConfig.get('/dashboard/pfizer/portfolios', { params: _.omit(selected, 'portfolios') });
	},

	/*
        GET 	/api/v1/dashboard/dropdown/product_names
        GET     /api/v1/product_names
	*/
	productNames(selected) {
		const companyID = localStorage.getItem('companyID');
		const decrypted = CryptoJS.AES.decrypt(companyID, process.env.VUE_APP_GOOGLE_SITE_KEY).toString(
			CryptoJS.enc.Utf8
		);

		const parsed_decrypted = JSON.parse(decrypted);

		if(!parsed_decrypted){
			localStorage.clear();
			window.location = '/';
		}
		else if (parsed_decrypted === 14) {
			return axiosConfig.get('/dashboard/pfizer/product_names', { params: _.omit(selected, 'product_names') });
		} else {
			return axiosConfig.get('/dashboard/product_names', { params: _.omit(selected, 'product_names') });
		}
	},

	/*
        GET 	/api/v1/dashboard/pfizer/substances
        GET 	/api/v1/dashboard/substances
	*/
	substances(selected) {
		const companyID = localStorage.getItem('companyID');
		const decrypted = CryptoJS.AES.decrypt(companyID, process.env.VUE_APP_GOOGLE_SITE_KEY).toString(
			CryptoJS.enc.Utf8
		);
		const parsed_decrypted = JSON.parse(decrypted);

		if(!parsed_decrypted){
			localStorage.clear();
			window.location = '/';
		}
		else if (parsed_decrypted === 14) {
			return axiosConfig.get('/dashboard/pfizer/substances', { params: _.omit(selected, 'substances') });
		} else {
			return axiosConfig.get('/dashboard/substances', { params: _.omit(selected, 'substances') });
		}
	},

	/*
        GET 	/api/v1/dashboard/pfizer/region
	*/
	regions(selected) {
		return axiosConfig.get('/dashboard/pfizer/regions', { params: _.omit(selected, 'regions') });
	},

	/*
        GET 	/api/v1/dashboard/pfizer/forms
        GET 	/api/v1/dashboard/forms
	*/
	forms(selected) {
		const companyID = localStorage.getItem('companyID');
		const decrypted = CryptoJS.AES.decrypt(companyID, process.env.VUE_APP_GOOGLE_SITE_KEY).toString(
			CryptoJS.enc.Utf8
		);

		const parsed_decrypted = JSON.parse(decrypted);

		if(!parsed_decrypted){
			localStorage.clear();
			window.location = '/';
		}
		else if (parsed_decrypted === 14) {
			return axiosConfig.get('/dashboard/pfizer/forms', { params: _.omit(selected, 'forms') });
		} else {
            return axiosConfig.get('/dashboard/forms', { params: _.omit(selected, 'forms') });
        }
	},

	/*
        GET 	/api/v1/dashboard/dashboard/strengths
	*/
	strengths(selected) {
		return axiosConfig.get('/dashboard/strengths', { params: _.omit(selected, 'strengths') });
	},

	/*
    |-------------------------------------------------------------------------------
    | Market overview
    |-------------------------------------------------------------------------------
    */

	/* 
        GET     /api/v1/market_hos_pha
    */
	// marketHosPha(selected) {
	// 	return axiosConfig.get('market_hos_pha', { params: selected });
	// },

	// /*
	//     GET     /api/v1/market_hos
	// */
	// marketHos(selected) {
	// 	return axiosConfig.get('market_hos', { params: selected });
	// },

	// /*
	//     GET     /api/v1/market_pha
	// */
	// marketPha(selected) {
	// 	return axiosConfig.get('market_pha', { params: selected });
	// },

	/*
    |-------------------------------------------------------------------------------
    | Product data
    |-------------------------------------------------------------------------------
    */

	/* 
        GET     /api/v1/product_indications
    */
	// indications(selected) {
	// 	return axiosConfig.get('product_indications', { params: selected });
	// },

	// /*
	//     GET     /api/v1/product_guidelines
	// */
	// guidelines(selected) {
	// 	return axiosConfig.get('product_guidelines', { params: selected });
	// },

	// /*
	//     GET     /api/v1/product_sources
	// */
	// sources(selected) {
	// 	return axiosConfig.get('product_sources', { params: selected });
	// },

	// /*
	//     GET     /api/v1/product_fass
	// */
	// fass(selected) {
	// 	return axiosConfig.get('product_fass', { params: selected });
	// },
};
